import styled from 'styled-components/macro';
import { ReactComponent as PencilIcon } from '../../../assets/svg/pencil.svg';

const Pencil = styled(PencilIcon)`
  stroke: ${({ theme }) => theme.palette.black};
`;

export default Pencil;
